import React from "react";
import "./style.scss";

export type ConsentCheckProps = {
  name: string;
  text: string;
  isChecked: boolean;
  setIsChecked: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled: boolean;
};

export const ConsentCheck = (props: ConsentCheckProps) => {
  const { name, text, isChecked, setIsChecked, disabled } = props;
  return (
    <label className="consentRadio">
      <input
        className="consentRadio_input"
        name={name}
        type="checkbox"
        checked={isChecked}
        onChange={setIsChecked}
        disabled={disabled}
      />
      <span className="consentRadio_text">{text}</span>
    </label>
  );
};
